import Link from 'next/link'
import * as React from 'react'

// @ts-ignore
import RawFormattedMessage from '../components/RawFormattedMessage'
import style from './DetailsLink.css'
import {
  chauffeurDetail,
  chauffeurDocumentUpload,
  finishedDetail,
  lspDocumentUpload,
  offerDetail,
  plannedDetail,
  vehicleDetail,
  vehicleDocumentUpload
  // @ts-ignore
} from '../routes'
import {
  QueryStringParams,
  LinkCreator,
  NotImplementedLink
} from '../../types/Link'
import { List } from '../../types/List'

interface DetailsLinkProps {
  inlined?: boolean
  isReviewable?: boolean
  labelKey?: string
  qs: QueryStringParams
  section: List
}

const detailLinkCallbacks: {
  [section in List]: LinkCreator | NotImplementedLink
} = {
  'chauffeur-docs': chauffeurDocumentUpload,
  'vehicle-docs': vehicleDocumentUpload,
  'lsp-docs': lspDocumentUpload,
  chauffeurs: chauffeurDetail,
  finished: finishedDetail,
  offers: offerDetail,
  planned: plannedDetail,
  ratings: () => null, // Won't be implemented
  vehicles: vehicleDetail
}

export default function DetailsLink ({
  inlined,
  labelKey,
  qs,
  section
}: DetailsLinkProps) {
  const link = detailLinkCallbacks[section]({ qs })
  if (link) {
    return (
      <Link prefetch={true} {...link}>
        <a className={inlined ? style.inlined : style.root}>
          <RawFormattedMessage id={labelKey || 'shared.details'} />
        </a>
      </Link>
    )
  }
  return null
}
